import createIcon from '../../createIcon';

/**
 * @component @name Tag
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMTBWOEgxNlY0SDE0VjhIMTBWNEg4VjhINFYxMEg4VjE0SDRWMTZIOFYyMEgxMFYxNkgxNFYyMEgxNlYxNkgyMFYxNEgxNlYxMEgyMFpNMTQgMTRIMTBWMTBIMTRWMTRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Tag = createIcon('Tag', [
  [
    'path',
    {
      d: 'M20 10V8H16V4H14V8H10V4H8V8H4V10H8V14H4V16H8V20H10V16H14V20H16V16H20V14H16V10H20ZM14 14H10V10H14V14Z',
      key: '37lvwn',
    },
  ],
]);

export default Tag;
